// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer_nav{
    position: fixed;
    top: 0;
    display: block;
    width: 100%;
    flex-direction: column;
    z-index: 1000;
}

.navbar a.active {
    color: var(--main-color);
  }

.section-navbar{
	width: 100%;
	height: 70px;
	background-color:'transparent';
	-webkit-backdrop-filter: blur(5px);
	        backdrop-filter: blur(5px);
	display:flex;
	justify-content: space-around;
	align-items: center;
	z-index: 1000;
}

.section-navbar i{
    display: none;
    color: var(--main-color);
}

.section-navbar .logo{
	font-size: 1.9rem;
	color: var(--text-color);
	font-weight: 500;
	cursor: default;   
}

.navbar{
	display:flex;
    flex-wrap: wrap;
    transition: 0.5s ease;
    opacity: 0;
    animation: slideTop 0.5s ease forwards;
    animation-delay: calc(.2s*var(--i))
}

@keyframes slideTop{
    0%{
      transform: translateY(100px);
      opacity: 0;
    }
    100%{
      transform: translateY(0);
      opacity: 1;
    }
}

.navbar1{
    position: relative;
    display: none;
    height: 100vh;
    background-color: #231c3969;
    font-size: 1.4rem;
    flex-wrap: wrap;
	color: var(--text-color);
    background-color:'transparent';
	-webkit-backdrop-filter: blur(6px);
	        backdrop-filter: blur(6px);
    align-items: center;
    justify-content:flex-start;    
    transition: 5s ease;
}

.navbar1{
    .btn {
        margin-top: 10px;
        display: flex;
        margin-bottom: 8vh;
        background: var(--main-color);
        color: var(--text-color);    
        border-radius: 4rem;
        box-shadow: 0 0 0.5rem var(--text-color);
        width: -moz-fit-content;
        width: fit-content;
        font-size: 1.5rem;
        letter-spacing: .1rem;
        font-weight: 600;
        transition: 2s ease;
        padding: 0.8rem 5rem 1rem 5rem ;
        cursor: pointer;
    }
}

.navbar a{
	font-size: 1.23rem;
	color: var(--text-color);
	margin-left: 2rem;
	transition: 0.3s;
    cursor: pointer;
}

.navbar a:hover ,
.navbar a.active {
	color: var(--main-color)
}

:root {
    --toggleHeight: 14.5em;
    --toggleWidth: 34em;
    --toggleBtnRadius: 10em;  
    --bgColor--night: #231c39;
    --mooncolor: #ffffff;
  }
  
body{
    transition: all 0.7s ease-in-out;
}

.light{
    background: var(--bg-color);
}
.tdnn {
    display: flex;
    font-size: 12%;
    margin-top: 5px;
    position: relative;
    height: var(--toggleHeight);
    width: var(--toggleWidth);
    border-radius: var(--toggleHeight);
    transition: all 700ms ease-in-out;
    background: var(--bgColor--night);
    cursor: pointer;
}

.day{
    background: #c4dde2;
}

.moon {
    position: absolute;
    display: block;
    border-radius: 50%;
    transition: all 400ms ease-in-out;    
    top: 1.5em;
    left: 2.7em;
    transform: rotate(-75deg);
    width: var(--toggleBtnRadius);
    height: var(--toggleBtnRadius);
    background: var(--bgColor--night);
    box-shadow: 
      3em 2.5em 0 0em var(--mooncolor) inset,
      rgba(255, 255, 255, 0.66) 3em 7em 0 -4.5em,
      rgba(255, 255, 255, 0.66) 2em 13em 0 -4em,
      rgba(255, 255, 255, 0.66) 6em 2em 0 -4.1em,
      rgba(255, 255, 255, 0.66) 8em 8em 0 -4.5em,
      rgba(255, 255, 255, 0.66) 6em 13em 0 -4.5em,
      rgba(255, 255, 255, 0.66) -4em 7em 0 -4.5em,
      rgba(255, 255, 255, 0.66) -1em 10em 0 -4.5em,
      rgba(255, 255, 255, 0.66) 5em 18em 0 -4.3em;
      
}

root{
--sun-col:#e9af31
}

.sun {
    top: 3em;
    left: 20em;
    transform: rotate(0deg);
    width: 7em;
    height: 7em;
    background: #fff;
    box-shadow: 3em 3em 0 5em #e9af31 inset,
      0 -5em 0 -2.7em #e9af31,
      3.5em -3.5em 0 -3em #e9af31,
      5em 0 0 -2.7em #e9af31,
      3.5em 3.5em 0 -3em #e9af31,
      0 5em 0 -2.7em #e9af31,
      -3.5em 3.5em 0 -3em #e9af31,
      -5em 0 0 -2.7em #e9af31,
      -3.5em -3.5em 0 -3em #e9af31;
}
.navbar1{
    display:none;
}

.navbar1_active{
    display: none;
}

@media(max-width:998px){
    .navbar{
        display: none;
    }
    .section-navbar i{
        display: block;
        font-size: 35px;
    
    }
    .section-navbar .logo{
        font-size: 1.4rem;
    }
    .navbar1_active{
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }  
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,wBAAwB;EAC1B;;AAEF;CACC,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,kCAA0B;SAA1B,0BAA0B;CAC1B,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,aAAa;AACd;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;CACxB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,YAAY;IACT,eAAe;IACf,qBAAqB;IACrB,UAAU;IACV,sCAAsC;IACtC;AACJ;;AAEA;IACI;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;CAClB,wBAAwB;IACrB,8BAA8B;CACjC,kCAA0B;SAA1B,0BAA0B;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,6BAA6B;QAC7B,wBAAwB;QACxB,mBAAmB;QACnB,wCAAwC;QACxC,uBAAkB;QAAlB,kBAAkB;QAClB,iBAAiB;QACjB,qBAAqB;QACrB,gBAAgB;QAChB,mBAAmB;QACnB,+BAA+B;QAC/B,eAAe;IACnB;AACJ;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;IACb,eAAe;AACnB;;AAEA;;CAEC;AACD;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;EACtB;;AAEF;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,kCAAkC;IAClC,iCAAiC;IACjC,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,iCAAiC;IACjC;;;;;;;;;iDAS6C;;AAEjD;;AAEA;AACA;AACA;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB;;;;;;;;kCAQ8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,eAAe;;IAEnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;AACJ","sourcesContent":[".outer_nav{\n    position: fixed;\n    top: 0;\n    display: block;\n    width: 100%;\n    flex-direction: column;\n    z-index: 1000;\n}\n\n.navbar a.active {\n    color: var(--main-color);\n  }\n\n.section-navbar{\n\twidth: 100%;\n\theight: 70px;\n\tbackground-color:'transparent';\n\tbackdrop-filter: blur(5px);\n\tdisplay:flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tz-index: 1000;\n}\n\n.section-navbar i{\n    display: none;\n    color: var(--main-color);\n}\n\n.section-navbar .logo{\n\tfont-size: 1.9rem;\n\tcolor: var(--text-color);\n\tfont-weight: 500;\n\tcursor: default;   \n}\n\n.navbar{\n\tdisplay:flex;\n    flex-wrap: wrap;\n    transition: 0.5s ease;\n    opacity: 0;\n    animation: slideTop 0.5s ease forwards;\n    animation-delay: calc(.2s*var(--i))\n}\n\n@keyframes slideTop{\n    0%{\n      transform: translateY(100px);\n      opacity: 0;\n    }\n    100%{\n      transform: translateY(0);\n      opacity: 1;\n    }\n}\n\n.navbar1{\n    position: relative;\n    display: none;\n    height: 100vh;\n    background-color: #231c3969;\n    font-size: 1.4rem;\n    flex-wrap: wrap;\n\tcolor: var(--text-color);\n    background-color:'transparent';\n\tbackdrop-filter: blur(6px);\n    align-items: center;\n    justify-content:flex-start;    \n    transition: 5s ease;\n}\n\n.navbar1{\n    .btn {\n        margin-top: 10px;\n        display: flex;\n        margin-bottom: 8vh;\n        background: var(--main-color);\n        color: var(--text-color);    \n        border-radius: 4rem;\n        box-shadow: 0 0 0.5rem var(--text-color);\n        width: fit-content;\n        font-size: 1.5rem;\n        letter-spacing: .1rem;\n        font-weight: 600;\n        transition: 2s ease;\n        padding: 0.8rem 5rem 1rem 5rem ;\n        cursor: pointer;\n    }\n}\n\n.navbar a{\n\tfont-size: 1.23rem;\n\tcolor: var(--text-color);\n\tmargin-left: 2rem;\n\ttransition: 0.3s;\n    cursor: pointer;\n}\n\n.navbar a:hover ,\n.navbar a.active {\n\tcolor: var(--main-color)\n}\n\n:root {\n    --toggleHeight: 14.5em;\n    --toggleWidth: 34em;\n    --toggleBtnRadius: 10em;  \n    --bgColor--night: #231c39;\n    --mooncolor: #ffffff;\n  }\n  \nbody{\n    transition: all 0.7s ease-in-out;\n}\n\n.light{\n    background: var(--bg-color);\n}\n.tdnn {\n    display: flex;\n    font-size: 12%;\n    margin-top: 5px;\n    position: relative;\n    height: var(--toggleHeight);\n    width: var(--toggleWidth);\n    border-radius: var(--toggleHeight);\n    transition: all 700ms ease-in-out;\n    background: var(--bgColor--night);\n    cursor: pointer;\n}\n\n.day{\n    background: #c4dde2;\n}\n\n.moon {\n    position: absolute;\n    display: block;\n    border-radius: 50%;\n    transition: all 400ms ease-in-out;    \n    top: 1.5em;\n    left: 2.7em;\n    transform: rotate(-75deg);\n    width: var(--toggleBtnRadius);\n    height: var(--toggleBtnRadius);\n    background: var(--bgColor--night);\n    box-shadow: \n      3em 2.5em 0 0em var(--mooncolor) inset,\n      rgba(255, 255, 255, 0.66) 3em 7em 0 -4.5em,\n      rgba(255, 255, 255, 0.66) 2em 13em 0 -4em,\n      rgba(255, 255, 255, 0.66) 6em 2em 0 -4.1em,\n      rgba(255, 255, 255, 0.66) 8em 8em 0 -4.5em,\n      rgba(255, 255, 255, 0.66) 6em 13em 0 -4.5em,\n      rgba(255, 255, 255, 0.66) -4em 7em 0 -4.5em,\n      rgba(255, 255, 255, 0.66) -1em 10em 0 -4.5em,\n      rgba(255, 255, 255, 0.66) 5em 18em 0 -4.3em;\n      \n}\n\nroot{\n--sun-col:#e9af31\n}\n\n.sun {\n    top: 3em;\n    left: 20em;\n    transform: rotate(0deg);\n    width: 7em;\n    height: 7em;\n    background: #fff;\n    box-shadow: 3em 3em 0 5em #e9af31 inset,\n      0 -5em 0 -2.7em #e9af31,\n      3.5em -3.5em 0 -3em #e9af31,\n      5em 0 0 -2.7em #e9af31,\n      3.5em 3.5em 0 -3em #e9af31,\n      0 5em 0 -2.7em #e9af31,\n      -3.5em 3.5em 0 -3em #e9af31,\n      -5em 0 0 -2.7em #e9af31,\n      -3.5em -3.5em 0 -3em #e9af31;\n}\n.navbar1{\n    display:none;\n}\n\n.navbar1_active{\n    display: none;\n}\n\n@media(max-width:998px){\n    .navbar{\n        display: none;\n    }\n    .section-navbar i{\n        display: block;\n        font-size: 35px;\n    \n    }\n    .section-navbar .logo{\n        font-size: 1.4rem;\n    }\n    .navbar1_active{\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n    }  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
